import { Link, Icon } from "@simplybusiness/mobius";
import type { IconDefinition } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";

export interface ChatLinkProps {
  /** Custom label text for the chat link. */
  label?: string;
  /** Custom icon to display. If not provided, defaults to message icon */
  icon?: IconDefinition;
  /** Question name when called from questionnaire */
  questionName?: string;
}

export const ChatLink = ({
  label = "Chat with a licensed agent",
  icon,
  questionName,
}: ChatLinkProps) => {
  const { snowplow } = useSnowplowContext();

  const handleClick = () => {
    snowplow?.trigger("helpChatLinkClicked", { label: questionName });
    if (window?.zE) {
      window.zE("messenger", "show");
      window.zE("messenger", "open");
    }
  };

  return (
    <div className="mobius-chatbox__chat-link">
      {icon && <Icon fixedWidth icon={icon} title="Start live chat" />}
      <Link onClick={handleClick}>
        <span>{label}</span>
      </Link>
    </div>
  );
};
